$(document).ready(function() {
  $('.headline1').each(function() {
    let html = $(this).html();
    let newHtml = html.replace(/\b(\w{9,})\b/g, '<span class="hyphenate-long">$1</span>');
    $(this).html(newHtml);
  });
});